module.exports = __webpack_public_path__ + "img/choose-transfer.e98e88db.svg";